// data/items/combatPendants.js
// Unique combat pendant drops from specific mobs
// Each has a unique effect that enables specific builds
// Stats are intentionally different from crafted pendants (jewelry.js) -
// less raw stats, but powerful unique effects

export const COMBAT_PENDANTS = [
    // === T1 Pendants (early zones) ===
    {
        id: 'bloodfang_pendant',
        name: 'Bloodfang Pendant',
        color: '#8b0000',
        value: 600,
        slot: 'neck',
        combatLevel: 10,
        defenseBonus: 3,
        // Unique: 3% lifesteal
        uniqueEffect: {
            type: 'lifesteal',
            value: 0.03,
            description: '3% of damage dealt is restored as HP'
        }
    },
    {
        id: 'shamans_focus',
        name: "Shaman's Focus",
        color: '#7b68ee',
        value: 650,
        slot: 'neck',
        combatLevel: 5,
        accuracy: 2,
        // Unique: +8% spell damage
        uniqueEffect: {
            type: 'spellDamageBonus',
            value: 0.08,
            description: '+8% spell damage'
        }
    },

    // === T2 Pendants (mid zones) ===
    {
        id: 'berserkers_tooth',
        name: "Berserker's Tooth",
        color: '#b22222',
        value: 1200,
        slot: 'neck',
        combatLevel: 30,
        defenseBonus: 4,
        // Unique: +10% damage below 50% HP, Rampage: +2 max stacks, +10s duration
        uniqueEffect: {
            type: 'berserkerEnhance',
            lowHpDamageBonus: 0.10,
            lowHpThreshold: 0.50,
            rampageExtraStacks: 2,
            rampageExtraDuration: 10000,
            description: '+10% damage below 50% HP. Berserker\'s Rampage: +2 max stacks, +10s duration'
        }
    },
    {
        id: 'scorched_talisman',
        name: 'Scorched Talisman',
        color: '#ff6347',
        value: 1400,
        slot: 'neck',
        combatLevel: 50,
        speedBonus: 3,
        // Unique: +20% DoT damage (bleeds + fire spells)
        uniqueEffect: {
            type: 'dotDamageBonus',
            value: 0.20,
            description: '+20% damage from bleeds and fire DoT effects'
        }
    },

    // === T3 Pendants (late zones) ===
    {
        id: 'dragons_heart',
        name: "Dragon's Heart",
        color: '#ff4500',
        value: 2200,
        slot: 'neck',
        combatLevel: 60,
        speedBonus: 3,
        accuracy: 2,
        critChance: 6,
        uniqueEffect: null  // Pure stat pendant — crit chance IS the unique effect
    },
    {
        id: 'void_siphon',
        name: 'Void Siphon',
        color: '#9932cc',
        value: 2800,
        slot: 'neck',
        combatLevel: 75,
        speedBonus: 2,
        critChance: 3,
        // Unique: +5% all damage
        uniqueEffect: {
            type: 'allDamageBonus',
            value: 0.05,
            description: '+5% all damage'
        }
    },
    {
        id: 'elder_sigil',
        name: 'Elder Sigil',
        color: '#daa520',
        value: 3500,
        slot: 'neck',
        combatLevel: 85,
        accuracy: 3,
        critChance: 5,
        // Unique: +10% all damage
        uniqueEffect: {
            type: 'allDamageBonus',
            value: 0.10,
            description: '+10% all damage'
        }
    },

    // === T4 Boss Pendant (Flame Eternal drop) ===
    {
        id: 'ember_ward',
        name: 'Ember Ward',
        color: '#ff4500',
        value: 5000,
        slot: 'neck',
        combatLevel: 80,
        speedBonus: 4,
        critChance: 5,
        // Unique: +12% all damage
        uniqueEffect: {
            type: 'allDamageBonus',
            value: 0.12,
            description: '+12% all damage, +5% crit, +4% speed'
        }
    }
];

export default COMBAT_PENDANTS;
